export default "__VITE_ASSET__rSL88S$D__"